// const shopname = 'senda';
const shopname = 'basto';
// const shopname = 'staccato';
// const shopname = 'teenmix';
// const shopname = 'bata';

// 测试   正式切换
// const version = 'ceshi-kaifa'
// const version = 'ceshi-fuwu'
// 正式
const version = 'shengchang'

const config = () => {
  let shopnamechina;
  let brandNo;
  if(shopname == 'senda'){
    shopnamechina = '森达';
    brandNo ='SD01'
  }else if(shopname == 'basto'){
    shopnamechina = '百思图';
    brandNo ='BS01'
  }else if(shopname == 'staccato'){
    shopnamechina = '思加图';
    brandNo ='ST01'
  }else if(shopname == 'teenmix'){
    shopnamechina = '天美意';
    brandNo ='TM01'
  }else if(shopname == 'bata'){
    shopnamechina = '拔佳';
    brandNo ='BT01'
  }
  if(version == 'ceshi-kaifa' || version == 'ceshi-fuwu'){
    let routerapi;
    if(version == 'ceshi-kaifa'){
      // routerapi = 'http://custom-mall-api-test.epoque.cn/v1/wechat/epoque'
      routerapi = 'http://custom-mall-api-test.epoque.cn/v1/wechat/oauth/entrance'
    }else if(version == 'ceshi-fuwu'){
        routerapi = 'http://custom-mall-api-test.epoque.cn/v1/wechat/oauth/entrance'
    }
    return {
      routerapi: routerapi,
      vouchernoApi: 'http://119.23.59.31:8091/',
      domainname: 'http://custom-mall-'+shopname+'-test.epoque.cn',
      router: 'http://custom-mall-api-test.epoque.cn',
      shopname:shopname,
      shopnamechina:shopnamechina,
      brandNo:brandNo,
      registeraddress: '&test=123',
      // payurl:"http://custom-mall-test.epoque.cn", // 测试不可付款
      payurl:"http://custom-mall.epoque.cn", // 生产不可付款
      version,
      // registeraddress: '',
    }
  }
  return {
    vouchernoApi: 'http://office.epoque.cn/api-v1.0/',
    domainname: 'http://custom-mall-'+shopname+'.epoque.cn',
    router: 'http://custom-mall-api.epoque.cn',
    routerapi: 'http://custom-mall-api.epoque.cn/v1/wechat/oauth/entrance',
    shopname:shopname,
    shopnamechina:shopnamechina,
    brandNo:brandNo,
    registeraddress:'',
    payurl:"http://custom-mall.epoque.cn",
    version,
  }
}

export default config()

// import config from '@/conf'
// `${config.maincolor}`



// WEBPACK FOOTER //
// ./src/conf/index.js